module.exports = __webpack_public_path__ + "static/media/LogicWheel6_1_continue_1.69ca4d28.png";